import { useParams, Link } from "react-router-dom";
import { ArrowLeft, User } from "lucide-react";
import { useUserAccount } from "../../hooks/useUserAccount";

export default function AdminAccountView() {
  const { id } = useParams<{ id: string }>();
  const { data: admin, isLoading: loading, error } = useUserAccount(id);

  if (loading && !admin) return <div className="text-center mt-10">Chargement...</div>;
  if (error) return <div className="text-center text-red-600 mt-10">{(error as any).message}</div>;
  if (!admin) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-6">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
              <User className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl sm:text-2xl font-bold text-gray-800">Détails de l’Administrateur</h1>
              <p className="text-gray-600 text-sm">Informations du compte #{id}</p>
            </div>
          </div>

          <Link
            to="/admin/dashboard/account/admin"
            className="px-4 py-2 bg-gray-600 text-white rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-all"
          >
            <ArrowLeft size={16} />
            Retour
          </Link>
        </div>

        <div className="space-y-4">
          <p><strong>Nom :</strong> {admin?.lastName}</p>
          <p><strong>Prénom :</strong> {admin?.firstName}</p>
          <p><strong>Email :</strong> {admin?.email}</p>
          <p><strong>Téléphone :</strong> {admin?.phone}</p>
          <p><strong>Adresse :</strong> {admin?.address}</p>
          <p><strong>Date de naissance :</strong> {new Date(admin?.dateOfBirth).toLocaleDateString("fr-FR")}</p>
          <p><strong>Genre :</strong> {admin?.gender === "M" ? "Masculin" : admin?.gender === "F" ? "Féminin" : "Autre"}</p>
        </div>
      </div>
    </div>
  );
}
